<template>
  <div class="sampleCard">
    <div class="content">
      <div class="img">
        <SkeletonWrapper :isLoading="true" class="fat-skeleton" />
      </div>
      <div class="info">
        <SkeletonWrapper :isLoading="true" class="line-skeleton" />
      </div>
      <div class="info">
        <SkeletonWrapper :isLoading="true" class="line-skeleton" />
      </div>
      <div class="info">
        <SkeletonWrapper :isLoading="true" class="line-skeleton" />
      </div>
      <div class="info action">
        <SkeletonWrapper :isLoading="true" class="action-skeleton" />
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonWrapper from '@common/skeleton-wrapper.vue';

export default {
  name: 'TripSampleCardSkeleton',
  props: {},
  components: {
    SkeletonWrapper,
  },
};
</script>

<style scoped>
.sampleCard {
  border-radius: var(--card-br-large);
  background-color: #f7f7f7;
  color: #fff;
  width: 300px;
  padding-left: 0;
  overflow: hidden;
  position: relative;
  display: block;
  border: none;
  appearance: none;
  text-align: left;
  box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13);
  cursor: pointer;
}

.sampleCard img {
  width: 50%;
  height: 100%;
  object-fit: cover;
}

.content {
  display: flex;
  flex-direction: column;
}

.img {
  height: 140px;
  position: relative;
}

.info {
  position: relative;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 40px;
  position: relative;
  background-position: 14px;
  background-size: 14px;
  padding-right: 14px;
}

.info + .info {
  border-top: 1px solid #f1f1f1;
}

.info:not(.action) {
  padding: 10px 30px 10px 55px;
}

.info:not(.action)::before {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  top: 50%;
  left: 15px;
  transform: translate(0px, -50%);
  background-color: #f1f1f1;
  background-repeat: no-repeat;
  background-position: center;
}

.line-skeleton {
  height: 22px;
  margin: 0 4px;
  margin-bottom: 5px;
}

.action-skeleton {
  height: 32px;
  margin: 0 4px;
  margin-bottom: 5px;
}

.fat-skeleton {
  height: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
